/**************
 Mobile Nav -- the phone + tablet drawer (1079px and down)
 25 Sep 2026: rebuilt with the Shop menu "option C". The burger and the X
 carry aria-expanded / aria-controls; each Shop group is an accordion
 button (aria-expanded, several may be open); focus is trapped in the
 drawer while it is open, Escape closes it and gives focus back to the
 burger; a tap beside the drawer (tablets) closes it; the page is locked.
 The drawer's photo cards load on the first touch of the burger, not with
 the page (see snippets/fgo-shop-menu-card.liquid).
 ***************/

(function () {
    var header = document.getElementById('header');
    var slider = document.getElementById('slider');
    var content = document.getElementById('sliderContent');
    var burger = document.getElementById('headerMenu');
    var closer = document.getElementById('headerClose');
    var body = document.body;
    if (!slider || !content) return;

    // move a card's real sources in (they wait in data-* so the page does not fetch them)
    var warm = function (scope) {
        if (!scope) return;
        var imgs = scope.querySelectorAll('img[data-src]');
        for (var i = 0; i < imgs.length; i++) {
            var img = imgs[i];
            img.loading = 'eager';
            if (img.dataset.srcset) img.srcset = img.dataset.srcset;
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            img.removeAttribute('data-srcset');
        }
    };

    // THE CARDS' PEEK (26 Sep 2026, menu audit 6). A card that is partly out of view (the next card's
    // edge in the snap scroller, or a card under the drawer's fold) shows its photo only, so a title is
    // never seen cut: one IntersectionObserver rooted on the drawer's scroller (it also honours the card
    // row's own horizontal clip) toggles .is-peek below 85% in view. Live only while the drawer is open.
    var peekIO = null;
    var watchCards = function () {
        if (peekIO || !('IntersectionObserver' in window)) return;
        var cards = content.querySelectorAll('.fgoDrawer__cards .fgoMenuCard');
        if (!cards.length) return;
        peekIO = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) entries[i].target.classList.toggle('is-peek', entries[i].intersectionRatio < .85);
        }, { root: content, threshold: .9 });
        for (var j = 0; j < cards.length; j++) peekIO.observe(cards[j]);
    };
    var unwatchCards = function () {
        if (!peekIO) return;
        peekIO.disconnect();
        peekIO = null;
    };

    // accordions: one listener for every group row
    content.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('.fgoDrawer__toggle') : null;
        if (!t) return;
        t.setAttribute('aria-expanded', t.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });

    // the drawer hangs from the bar's lower edge down to the bottom of the screen
    var placed = -1;
    var place = function () {
        if (!header) return;
        var b = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        if (b === placed) return;   // unchanged: no write, no restyle
        placed = b;
        slider.style.setProperty('--fgo-drawer-top', b + 'px');
    };

    var isOpen = function () { return slider.classList.contains('active'); };

    var focusables = function () {
        var list = [];
        if (closer && closer.offsetWidth) list.push(closer);
        var els = content.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
        for (var i = 0; i < els.length; i++) {
            var el = els[i];
            if (el.disabled) continue;
            // a collapsed group's links are visibility:hidden: checked before the rect read
            if (el.checkVisibility ? !el.checkVisibility({ visibilityProperty: true }) : getComputedStyle(el).visibility === 'hidden') continue;
            if (!el.getClientRects().length) continue;
            list.push(el);
        }
        return list;
    };

    var onKey = function (e) {
        if (!isOpen()) return;
        if (e.key === 'Escape') {
            e.preventDefault();
            closeNav(true);
            return;
        }
        if (e.key !== 'Tab') return;
        // the X sits in the bar, away from the drawer in the DOM, so the order is stated, not left to the page
        var f = focusables();
        if (!f.length) return;
        var i = f.indexOf(document.activeElement);
        e.preventDefault();
        if (i < 0) { (e.shiftKey ? f[f.length - 1] : f[0]).focus(); return; }
        f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
    };

    var setExpanded = function (on) {
        if (burger) burger.setAttribute('aria-expanded', on ? 'true' : 'false');
    };

    // Work that does not change the first frame runs just after it: the page lock (a
    // full-page relayout on a big page) and the focus move (a forced restyle). The tap
    // is answered by the drawer starting to slide, one frame sooner (Event Timing, 25 Sep).
    var afterPaint = function (fn) {
        var done = false;
        var run = function () { if (done) return; done = true; fn(); };
        requestAnimationFrame(function () { setTimeout(run, 0); });
        setTimeout(run, 120);   // a hidden or throttled tab may never paint
    };

    function openNav() {
        if (isOpen()) return;
        warm(content);
        slider.classList.add('active');
        if (burger) burger.classList.remove('active');
        if (closer) closer.classList.add('active');
        setExpanded(true);
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', place, { passive: true });
        // 27 Sep 2026 (perf audit INP-10): the focus move now comes BEFORE the page lock. focus()
        // makes the browser restyle and lay out on the spot, and after body.noScroll that meant a
        // whole-page relayout inside this task; before it, focus() costs the drawer's own restyle and
        // the lock's relayout is left to the next frame. The lock itself stays body.noScroll: it runs
        // after the drawer's first frame, so it is not part of the tap's INP, and every other way to
        // stop the page scrolling behind a drawer that hangs from a sticky bar needs touch and wheel
        // traps on iOS Safari that this does not.
        // Burger on the phone lab after the whole track (A/B, 4x, n=5 per arm, two runs): open INP
        // median 88 -> 80 and 104 -> 80 ms (presentation 49 -> 41, 51 -> 40), close 56 -> 48 and
        // 64 -> 48 ms; the restyle while opening 366-370 -> 230-244 elements.
        afterPaint(function () {
            if (!isOpen()) return;
            place();
            // the X takes the burger's place; focus follows it so the next Tab is the first row
            if (closer) closer.focus({ preventScroll: true });
            body.classList.add('noScroll');
            watchCards();
        });
    }

    // byKey === true: closed with Escape, so focus always goes back to the burger (a click
    // handler passes an Event here, never true)
    function closeNav(byKey) {
        var wasOpen = isOpen();
        var a = document.activeElement;
        var hadFocus = byKey === true || (!!a && (a === closer || content.contains(a)));
        slider.classList.remove('active');
        if (burger) burger.classList.add('active');
        if (closer) closer.classList.remove('active');
        setExpanded(false);
        document.removeEventListener('keydown', onKey);
        window.removeEventListener('resize', place);
        unwatchCards();
        // focus back to the burger first, then the unlock (27 Sep 2026, same reason as openNav)
        afterPaint(function () {
            if (isOpen()) return;
            if (wasOpen && hadFocus && burger && burger.offsetWidth) burger.focus({ preventScroll: true });
            body.classList.remove('noScroll');
        });
    }

    // the bar's lower edge is stable (the bar is flush under the promo strip in every state),
    // so it is measured ahead of time and re-checked after each open.
    // 27 Sep 2026: measured just AFTER a frame (afterPaint), not at the start of one. With
    // fgo-header.js no longer paying for the page's first restyle while it runs, this read was
    // the first to ask for layout at load, and inside requestAnimationFrame it restyled the page
    // on the spot: 2,619 elements, 194 ms of forced style per desktop session at 4x (trace
    // stacks). After the frame the layout is already clean and the read is free.
    var measureSoon = function () { afterPaint(place); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measureSoon); else measureSoon();
    window.addEventListener('load', measureSoon);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureSoon).catch(function () {});

    window.openNav = openNav;
    window.closeNav = closeNav;

    // warm the cards on the first touch or focus of the burger, ahead of the slide
    if (burger) {
        burger.addEventListener('pointerdown', function () { warm(content); }, { passive: true });
        burger.addEventListener('focus', function () { warm(content); });
    }

    document.querySelectorAll('.openNav').forEach(function (element) {
        element.addEventListener('click', openNav);
    });
    document.querySelectorAll('.closeNav').forEach(function (element) {
        element.addEventListener('click', closeNav);
    });

    // back/forward cache: never come back to a page with the drawer open and the page locked
    window.addEventListener('pageshow', function (e) { if (e.persisted && isOpen()) closeNav(); });
}());

// header scroll change background
//
// 27 Sep 2026 (perf audit, header scroll cost): the theme's own scroll handler is gone. On every
// scroll event it read the header's rect and rewrote .bg on #header and .active on both logos from a
// "top <= 13px" test. Under the sticky promo bar that test is false whenever the docked bar shows,
// so it stripped .bg there on each event and fgo-header.js put it back in the same frame; hidden,
// it re-set the same classes (measured: 60 class writes on #header for 60 scroll events, 1440 and
// 390). A rect read and class churn per event, for a result that never painted: fgo-header.js
// (HEADER dock) owns .bg, .fgo-docked and the logos' .active on every template and always had the
// last word, so the painted states are the ones they were. The constants stay: the search block
// below uses header.
// Measured with fgo-header.js's single scrollY read (A/B, home, 4x): the desktop scroll session's
// forced style went 531-644 ms -> 69-82 ms, and the phone's style recalcs while scrolling 198-239 -> 17-22.
const header = document.querySelector('#header');
const headerLogo = document.querySelector('#headerLogo');
const headerLogoAlt = document.querySelector('#headerLogoAlt');

// toggle open header search

const searchButton = document.querySelector('#headerRightIconsSearch');
const headerSearch = document?.querySelector('#headerSearch');
const headerSearchClose = document?.querySelector('.headerSearchFormClose');


if (headerSearch) {
    const query = headerSearch.querySelector('#headerSearchFormQuery');
    /* 26 Sep 2026 (INP audit 4). Two things moved out of the tap's own frame:
       1. The open state is ALSO a class on #header (is-searching), set here, so theme-header.css
          keys its two "search is open" rules on it instead of #header:has(#headerSearch.active),
          which made every toggle re-match the whole header.
       2. Focus moves run in requestAnimationFrame after the class change: a focus() call forces
          style and layout for the page on the spot (315ms per close at 4x on production, the
          audit measured), and a frame later it costs the layout the frame does anyway.
       One exception: a finger on the magnifier keeps the synchronous focus, because iOS only
       raises the keyboard for a focus made inside the tap itself. */
    const setSearching = function (on) {
        headerSearch.classList.toggle('active', on);
        if (header) header.classList.toggle('is-searching', on);
        searchButton.setAttribute('aria-expanded', on ? 'true' : 'false');
    };
    const byTouch = function (e) {
        if (e && typeof e.pointerType === 'string' && e.pointerType !== '') return e.pointerType !== 'mouse';
        return !!(window.matchMedia && matchMedia('(hover: none)').matches);
    };
    searchButton.addEventListener('click', function (e) {
        const open = !headerSearch.classList.contains('active');
        query.value = "";
        setSearching(open);
        if (!open) { query.blur(); return; }
        if (byTouch(e)) { query.focus({ preventScroll: true }); return; }   // inside the tap: the keyboard
        requestAnimationFrame(function () { if (headerSearch.classList.contains('active')) query.focus({ preventScroll: true }); });
    });
    searchButton.setAttribute('aria-expanded', 'false');
    searchButton.setAttribute('aria-controls', 'headerSearch');

// populate the search input with the clicked item (a tap, or Enter / Space from the keyboard)
    headerSearch.querySelectorAll('.headerSearchRecsItemGroupExample').forEach(example => {
        const pick = function () {
            const searchInput = headerSearch.querySelector('#headerSearchFormQuery');
            searchInput.value = example.textContent.trim();   /* as written, not the capitals the CSS shows */
            headerSearch.querySelector('#headerSearchForm').submit();
        };
        example.addEventListener('click', pick);
        example.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
        });
    })

// close the search panel: the X, Escape, or a click anywhere outside it (24 Sep 2026)
    const closeSearch = function (returnFocus) {
        if (!headerSearch.classList.contains('active')) {
            return;
        }
        setSearching(false);
        query.value = "";
        // focus goes back to the magnifier a frame after the panel is told to go (see above)
        if (returnFocus) { requestAnimationFrame(function () { searchButton.focus({ preventScroll: true }); }); }
    };
    headerSearchClose.addEventListener('click', function () { closeSearch(true); });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && headerSearch.classList.contains('active')) { closeSearch(true); }
    });
    document.addEventListener('click', function (e) {
        if (!headerSearch.classList.contains('active')) { return; }
        if (headerSearch.contains(e.target) || searchButton.contains(e.target)) { return; }
        closeSearch(false);
    });
}
